import React from 'react';
import { history } from 'util/helpers/history';

export default class HandleRedirect extends React.Component {
  componentDidMount() {
    let paymentType = history.location.pathname.split('/')[4];
    if (paymentType === 'mandate') {
      history.replace('/extend/vignette/steps', { route: 'mandate' });
    } else if (paymentType === 'direct') {
      history.replace('/extend/vignette/steps', { route: 'ideal' });
    } else if (paymentType === 'mandate-cancel') {
      history.replace('/extend/vignette/steps', {
        route: 'mandate-failed',
        id: 'extend.step.payment.mandate.cancel.message',
      });
    } else if (paymentType === 'mandate-error') {
      history.replace('/extend/vignette/steps', {
        route: 'mandate-failed',
        id: 'extend.step.payment.mandate.error.message',
      });
    } else if (paymentType === 'mandate-reject') {
      history.replace('/extend/vignette/steps', {
        route: 'mandate-failed',
        id: 'extend.step.payment.mandate.reject.message',
      });
    } else if (paymentType === 'direct-cancel') {
      history.replace('/extend/vignette/steps', {
        route: 'direct-failed',
        id: 'extend.step.payment.direct.cancel.message',
      });
    } else if (paymentType === 'direct-error') {
      history.replace('/extend/vignette/steps', {
        route: 'direct-failed',
        id: 'extend.step.payment.direct.error.message',
      });
    } else if (paymentType === 'direct-reject') {
      history.replace('/extend/vignette/steps', {
        route: 'direct-failed',
        id: 'extend.step.payment.direct.reject.message',
      });
    }
  }

  render() {
    return null;
  }
}
